module.exports = __webpack_public_path__ + "img/GS_Profile-Matshidiso Mokhele.7b43d5a7.png";